$(window).on("load", function () {
  var swiper = new Swiper(".swiper-story", {
    navigation: {
      nextEl: ".swiper-story .swiper-button-next",
      prevEl: ".swiper-story .swiper-button-prev",
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
  });
});
